import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=dddc7a6c&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Register.vue?vue&type=style&index=0&id=dddc7a6c&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "dddc7a6c",
  null
  ,true
)

export default component.exports